import React from 'react';
import './styles.scss';

const SearchInput = ({
  placeholder,
  value,
  handleChange,
  className
}: {
  placeholder?: string;
  value: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}) => {
  return (
    <div className={`search__input__container ${className}`}>
      <input
        type='search'
        className='search__input'
        placeholder={placeholder || 'Search'}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchInput;
